import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { PhxTypeaheadComponent } from './typeahead.component';
import { PhxInputModule } from './../input/phx-input.module';
import { PhxDropdownModule } from './../dropdown/phx-dropdown.module';
import { PhxDropdownService } from './../dropdown/phx-dropdown.service';
import { PhxMenuModule } from './../menu/menu.module';
import { PhxDividerModule } from './../divider/phx-divider.module';
import { PhxIconModule } from '../icon/icon.module';
import { PhxTranslationsRootModule } from '../../translation/transloco-root.module';
import { PhxSpinnerModule } from '../spinner/phx-spinner.module';

@NgModule({
  declarations: [
    PhxTypeaheadComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    PhxInputModule,
    PhxDropdownModule,
    PhxMenuModule,
    PhxDividerModule,
    PhxIconModule,
    PhxTranslationsRootModule,
    PhxSpinnerModule
  ],
  exports: [
    PhxTypeaheadComponent
  ],
  providers: [PhxDropdownService],
})
export class PhxTypeaheadModule { }
